// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Organizers_header-wrapper__RDcae","organizer-header":"Organizers_organizer-header__2YExH","ieee":"Organizers_ieee__3-L3b","signal":"Organizers_signal__1Zf0D"};